export default "__VITE_ASSET__kvoXoihE__"